














export default {
    name: 'BaseSideBarListItem',
    components: {},
    props: {
        link: {
            type: Object,
            required: true,
        },
        icon: {
            type: String,
            required: true,
        },
        text: {
            type: String,
            required: true,
        },
    },
    data() {
        return {};
    },
    methods: {},
};
